<template>
  <div class="options-row row BoxStyle" :class="[{'RemoveControl':clicked!==-1}]">
    <div class="col-12 text-center HeaderPositionQuestion">
      <div class="arrow" :class="['fade', {'fade-in': closeTextEnable}]"></div>
      <p :class="['mb-0 pa-5 close-text fade  mt-3   ', {'fade-in': closeTextEnable}]">
        Hey, you can always
        click here
        if you are unsure about the answer.
      </p>

      <h1 id="questionTitle" class="redText main-title" :class="['fade', {'fade-in':question}]">
        Find the character for ‘year’
        <img
          class="x-btn"
          style="cursor: pointer;float: right"
          @mouseenter="buttonHover"
          :src="require(`@/assets/img/Question.png`)"
          alt
          @click="closeClick"
        />
      </h1>
    </div>
    <div
      class="col-4 mx-2 mt-3 fade options image"
      style="transition: all 0.6s ease!important;"
      v-for="(i, index) in list"
      :key="i"
      :style="{border:clicked !== -1 || ShowMe?'unset':''}"
      :class="[{'fade-in':images,'active': active === i,
                                'RemoveAnimation':clicked !== -1 &&  clicked !== index ,
                  'clicked hinted': clicked === index && ShowMe!== true,
                  'move-right': ( ( (clicked===2 && index===1) || (clicked===1 && index===2 ) || (clicked===0 && index===2 ) ) && ShowMe!== true ),
                  'move-left': ( ( (clicked===2 && index===0) || (clicked===1 && index===0 ) || (clicked===0 && index===1 ) ) && ShowMe!== true),
                  },
                   `index-${list.length===1?1:index}`,
                    `${ControlToShow(index)}`,
                   `l3q6option-${i}`]"
    >
      <template v-if="index===1">
        <v-img
          :src="require(`./images/${i}.png`)"
          @mouseenter="mouseover(i)"
          @mouseleave="mouseleave()"
          @click="imgClick(i, index)"
        />
      </template>
      <template v-else>
        <v-img
          :src="require(`./images/${i}.png`)"
          @mouseenter="mouseover(i)"
          @mouseleave="mouseleave()"
          @click="imgClick(i, index)"
        />
      </template>
      <template v-if="i===2">
        <div
          class="wrong"
          v-if="wrongShow===true && list[clicked] === i"
          :style="{
            left: '94%',
            top: '23%',
          }"
        ></div>
      </template>
      <template v-if="i===3">
        <div
          class="wrong"
          v-if="wrongShow===true && list[clicked] === i"
          :style="{
            left: '73%',
            top: '8%' ,
            width: '70px',
            height: '70px'
          }"
        ></div>
      </template>
      <template v-if="i===2 && pregress">
          <img class="p21" src="./images/21.png" alt="pic">
          <img class="p22" src="./images/22.png" alt="pic">
          <img class="p23" src="./images/23.png" alt="pic">
          <img class="roof" src="./images/roof-01.png" alt="pic">
          <img class="train2" src="./images/train-02.png" alt="pic">
      </template>
      <template v-if="i===3 && pregress">
          <img class="p31" src="./images/21.png" alt="pic">
          <img class="p32" src="./images/22.png" alt="pic">
          <img class="roof1" src="./images/roof-01.png" alt="pic">
          <img class="train21" src="./images/train-02.png" alt="pic">
      </template>
    </div>

    <div
      style="bottom: 10px;position: absolute;padding: 10px "
      :class="{'fade hints-row': true, 'fade-in':textBoxEnable===1, 'fade-out':textBoxEnable===2 }"
    >
      <div
        class="col-12 p-0"
        v-for="(i) in list"
        :key="i"
        :class="[{'active': active === i, }]"
        style="padding: 0"
      >
        <div v-if="textBox[i] !== ''" class="pt-5">
          <div class="pt-5 mt-4">
            <div v-if="textBox[i] !== ''" class="text-box py-3 px-3 align-center text-center">
              <p class="mb-0 mr-3">{{textBox[i]}}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Question6",

  data() {
    return {
      pregress: false,
      wrongShow: false,
      ShowMe: false,
      textBoxEnable: 0,
      closeTextEnable: false,
      images: false,
      question: false,
      active: 0,
      clicked: -1,
      list: [1, 2, 3],
      textBox: {
        1: "",
        2: "",
        3: ""
      },
      hints: {
        1: "",
        2: `You may remember that this character is shaped as a train stopping at a station. However, the train should be above ground!`,
        3: `Remember that this character is shaped as a train stopping at a station. There’s no train in this station!`
      },
      hinted: false,
      mouse_over: "/sound/new mouse over.wav",
    };
  },
  props: {
    playSound: {
      type: Function
    },
    shuffle: {
      type: Function
    },
    finish: {
      type: Function
    },
    buttonHover: {
      type: Function
    }
  },
  mounted() {
    this.images = false;
    this.list = this.shuffle(this.list);

    this.playSound(require("./sounds/3-1.wav"));
    setTimeout(() => {
      this.question = true;

      setTimeout(() => {
        this.images = true;
      }, 2000);
      setTimeout(() => {
        this.closeTextEnable = true;
        this.playSound("/sound/textbox shows.wav");
        setTimeout(() => {
          this.closeTextEnable = false;
        }, 5000);
      }, 3000);
    }, 500);
  },
  methods: {
    closeClick() {
      if (this.ShowMe === true || this.pregress === true) {
        return;
      }
      if (this.clicked !== -1 || this.ShowMe) {
        return;
      }
      this.pregress = true;
      this.ShowMe = false;
      this.playSound("/sound/button click.wav").then(() => {
        setTimeout(() => {
          this.textBox = {
            1: "",
            2: "",
            3: ""
          };
          setTimeout(() => {
            this.clicked = this.list.indexOf(2);
            this.textBox[2] = JSON.parse(JSON.stringify(this.hints[2]));
            this.hinted = true;
            this.playSound("/sound/textbox shows.wav");
            this.makeSetTimeout();
            this.playSound(require("./sounds/3-11.wav")).then(() => {
              setTimeout(() => {
                this.playSound("/sound/textbox shows.wav");
                setTimeout(()=>{
                  this.clicked = this.list.indexOf(3);
                  this.textBox[2] = "";
                  this.textBox[3] = JSON.parse(JSON.stringify(this.hints[3]));
                  this.mistake2motion();
                  this.playSound(require("./sounds/3-12.wav")).then(() => {
                    setTimeout(() => {
                      this.playSound("/sound/correct answer.wav");
                      this.textBox = {
                        1: "",
                        2: "",
                        3: ""
                      };
                      this.list = [3, 1, 2];
                      this.clicked = this.list.indexOf(1);
  
                      setTimeout(() => {
                        this.hinted = false;
                        this.textBoxEnable = 0;
                        this.list = this.shuffle(this.list);
                        this.pregress = false;
                        this.active = 0;
                        this.ShowMe = false;
                        this.clicked = -1;
                      }, 3000);
                    }, 5000);
                  });
                },50)
              }, 4000);
            });

            this.textBoxEnable = 1;
          }, 50);
        });
      }, 1000);
    },
    mouseleave() {
      this.active = 0;
    },
    mouseover(i) {
      if (this.clicked !== -1 || this.ShowMe) {
        return;
      }
      this.active = i;
      this.playSound(this.mouse_over);
    },
    ControlToShow(i) {
      if (this.ShowMe) {
        if (i === 0) {
          return "RemoveAnimation";
        }
        if (i === 2) {
          return "RemoveAnimation";
        }
      } else {
        return "Scale1";
      }
      return "";
    },
    showWrong() {
      setTimeout(() => {
        this.wrongShow = true;
      }, 1900);
      setTimeout(() => {
        this.wrongShow = false;
      }, 6000);
    },
    closeTextBox() {
      this.textBoxEnable = 2;
      this.hinted = false;
      setTimeout(() => {
        this.textBox = {
          1: "",
          2: "",
          3: ""
        };
        this.textBoxEnable = 0;
        this.clicked = -1;
      }, 1000);
    },
    makeSetTimeout() {
      const p21 = document.querySelector('.p21')
      const p22 = document.querySelector('.p22')
      const p23 = document.querySelector('.p23')
      const roof = document.querySelector('.roof')
      const train = document.querySelector('.train2')
      setTimeout(() => {
        p21.style = "opacity: 1; transition: all 1s ease;";
        p22.style = "opacity: 1; transition: all 1s ease;";
        p23.style = "opacity: 1; transition: all 1s ease;";
      }, 1500)
      setTimeout(() => {
        p21.style = "opacity: 0; transition: all 1s ease;";
        p23.style = "opacity: 0; transition: all 1s ease;";
        roof.style = "opacity: 1; transition: all 1s ease;";
        train.style = "opacity: 1; transition: all 1s ease;";
      }, 3000)
      setTimeout(() => {
        train.style = "opacity: 0.5; transition: all 1s ease;";
      }, 3600)
      setTimeout(() => {
        train.style = "opacity: 1; transition: all 1s ease;";
      }, 4200)
      setTimeout(() => {
        train.style = "opacity: 0.5; transition: all 1s ease;";
      }, 4800)
      setTimeout(() => {
        train.style = "opacity: 1; transition: all 1s ease;";
      }, 5400)
      setTimeout(() => {
        p22.style = "top: 30%; opacity: 1; transition: all 1s ease;";
        train.style = "top: 45%; opacity: 1; transform: rotate(0deg); transition: all 1s ease;";
      }, 7000)
    },
    mistake2motion() {
      const p31 = document.querySelector('.p31')
      const p32 = document.querySelector('.p32')
      const roof = document.querySelector('.roof1')
      const train = document.querySelector('.train21')
      setTimeout(() => {
        p31.style = "opacity: 1; transition: all 1s ease;";
        p32.style = "opacity: 1; transition: all 1s ease;";
      }, 1500)
      setTimeout(() => {
        p31.style = "opacity: 0; transition: all 1s ease;";
        roof.style = "opacity: 1; transition: all 1s ease;";
      }, 3000)
      setTimeout(() => {
        train.style = "left: 85%; transition: all 1s ease;";
      }, 4500)
    },
    successFinish() {
      setTimeout(() => {
        this.pregress = false;
        this.closeTextBox();
      }, 3000);
      this.playSound("/sound/correct answer.wav");
      this.finish();
    },
    finishMition(velocity) {
      setTimeout(() => {
        this.clicked = -1;
        this.textBox = {
          1: "",
          2: "",
          3: ""
        };
        this.pregress = false;
      }, velocity);
    },
    imgClick(i, index) {
      if (this.clicked !== -1 || this.ShowMe || this.pregress === true) {
        return;
      }
      this.pregress = true;
      setTimeout(() => {
        this.hinted = false;
        this.clicked = index;
        this.textBox = {
          1: "",
          2: "",
          3: ""
        };
        if (i === 1) {
          this.successFinish();
        } else {
          this.playSound("/sound/highlight.wav");
          this.clicked = index;
          if (i === 2) {
            this.textBox[i] = this.hints[i];
            this.makeSetTimeout();
            this.playSound(require("./sounds/3-11.wav")).then(() => {
              this.finishMition(1800);
            })
          } else {
            this.textBox[i] = this.hints[i];
            this.mistake2motion();
            this.playSound(require("./sounds/3-12.wav")).then(() => {
              this.finishMition(1800);
            });
          }
          setTimeout(() => {
            this.playSound("/sound/textbox shows.wav");
            this.textBoxEnable = 1;
          }, 1000);
          setTimeout(() => {}, 1000);
        }
      }, 200);
    }
  }
};
</script>

<style lang="scss">
.l3q6option-2 {
  .p21{
    position: absolute;
    top: 12%;
    left: 76%;
    opacity: 0;
    transition: all 1s ease;
    width: 55%;
  }
  .p22{
    position: absolute;
    top: 13%;
    left: 76%;
    opacity: 0;
    transition: all 1s ease;
    width: 55%;
    z-index: 1;
  }
  .p23{
    position: absolute;
    top: 12%;
    left: 76%;
    opacity: 0;
    transition: all 1s ease;
    width: 55%;
  }
  .roof{
    position: absolute;
    top: 12%;
    left: 62%;
    opacity: 0;
    transition: all 1s ease;
    width: 83%;
  }
  .train2{
    position: absolute;
    top: 55%;
    left: 85%;
    opacity: 0;
    transition: all 1s ease;
    width: 37%;
    transform: rotate(180deg);
  }
  .v-image {
    left: 0;
  }

  &.hinted {
    .v-image {
      transition-delay: 4s;
      transition: left 2s;
      left: -50%;
    }
  }
}

@keyframes width_up {
  0% {
    width: 57%;
    left: 70%;
  }
  100% {
    width: 100%;
    left: 48.9%;
  }
}

.l3q6option-3 {
  .p31{
    position: absolute;
    top: 12%;
    left: 76%;
    opacity: 0;
    transition: all 1s ease;
    width: 55%;
  }
  .p32{
    position: absolute;
    top: 28%;
    left: 76%;
    opacity: 0;
    transition: all 1s ease;
    width: 55%;
    z-index: 1;
  }
  .roof1{
    position: absolute;
    top: 12%;
    left: 62%;
    opacity: 0;
    transition: all 1s ease;
    width: 83%;
  }
  .train21{
    position: absolute;
    top: 43%;
    left: 885%;
    transition: all 1s ease;
    width: 37%;
  }
  .v-image {
    left: unset;
  }

  &.hinted {
    .v-image {
      transition-delay: 4s;
      transition: all 2s;
      left: -50%;
      /*opacity: 0;*/
    }
  }
}

@keyframes transformUp {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(-22.5deg);
    left: 68.2%;
  }
}

@keyframes transformDown {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(22.5deg);
  }
}
</style>